<template>
  <div class="container" v-if="isShow">
    <div class="progress-wrap">
      <circle-progress
        :progress="progress"
        :is_finished="is_finished"
        @updateStatus="updateStatus"></circle-progress>
    </div>
    <div class="progress-tips">
      <h1>{{audit_desc.title}}</h1>
      <p v-if="!show_finished_icon">{{audit_desc.content}}</p>
      <p v-else>{{audit_desc.finished_content}} (1s)</p>
    </div>
    <div class="bottom" v-if="!is_finished">
      <input type="button" :value="continueBtn.un_check.title" @click="toNextUpload" :style="continue_btn_style"/>
      <p @click="toPhotoList">{{back_link.title}}<span class="right-arrow"></span></p>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ends } from "../tools/constant";
import { post } from "../tools/request";
import { showLoadingToast, showAlertDialog } from "../tools/Tip";
import { SUPPORT_COUNTRY as sc } from "../tools/constant";
import CircleProgress from "./base/circle-progress"
export default {
  components: { CircleProgress },
  data() {
    return {
      formItem: {},
      isShow: false,
      show_finished_icon: false
    };
  },
  created(){
    this.getPhotoProgress();
  },
  computed: {
    ...mapState(["_ticket"]),
    country() {
      //notes set default country
      let c = new URLSearchParams(location.search).get("location_country");
      return sc[c] || "Mx";
    },
    progress() {
      return this.formItem.progress || {}
    },
    audit_desc() {
      return this.formItem.audit_desc || {}
    },
    back_link() {
      return this.formItem.back || {}
    },
    continueBtn() {
      return (this.formItem.button || {}).button_color || { un_check: {}, is_check: {} };
    },
    continue_btn_style() {
      let btnColor = this.continueBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
      }
    },
    continuePhoto() {
      return (this.formItem.button || {}).next || {}
    },
    is_finished() {
      return this.formItem.is_finished
    }
  },
  methods: {
    getPhotoProgress() {
      showLoadingToast(this)
      let up = new URLSearchParams(location.search);
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      post(process.env.GET_NEXTUPLOAD, up)
        .then((res) => {
          this.formItem = res;
        })
        .catch(this.httpError)
        .finally(() => {
          this.toast.hide()
          this.isShow = true
        });
    },
    toNextUpload() {
      let rou = {
        portrait: false ? `upload${this.country}` : `uploadCut${this.country}`,
        photo: `upload${this.country}`,
        declare: `declare${this.country}`,
        "linkage-photo": `linkageUpload${this.country}`,
        "link-photo": `linkUpload${this.country}`,
        "multi-photo": `multiUpload${this.country}`,
        "multi-declare": `multiDeclare${this.country}`,
        color: `setColor${this.country}`,
        introduce: `introduce${this.country}`,
        "select-photo": `selectPhoto${this.country}`,
        "photo_new": `uploadNew`,
        "inner-input": `detailMultiUpload${this.country}`,
      }[this.continuePhoto.type];

      this.$router.replace({
        name: rou,
        params: { configs: this.continuePhoto }
      });
    },
    toPhotoList() {
      this.$router.replace({ name: "home" });
    },
    updateStatus() {
      this.show_finished_icon = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  height: 100%;
  overflow: hidden;
  padding: 0 0.32rem;
  background: #ffffff;
  .progress-wrap {
    width: 160px;
    height: 160px;
    margin: 0 auto;
    margin-top: 1.68rem;
    // background: #FFDC14;
  }
  .progress-tips {
    margin-top: 0.4rem;
    text-align: center;
    > h1 {
      font-weight: 500;
      font-size: .48rem;
      color: #0F1928;
      line-height: .56rem;
    }
    > p {
      margin-top: 0.18rem;
      font-size: .28rem;
      color: #808080;
      line-height: .4rem;
    }
  }
  .bottom {
    position: fixed;
    box-sizing: border-box;
    padding: 0 0.32rem;
    width: 100%;
    bottom: 0.6rem;
    left: 0;
    text-align: center;
    > input {
      width: 100%;
      height: 1.08rem;
      padding: .3rem .2rem;
      box-sizing: border-box;
      font-size: .36rem;
      background: #FFDC14;
      color: #333333;
      font-weight: bold;
      border-radius: .12rem;

    }
    > p {
      width: fit-content;
      margin: .4rem auto 0;
      line-height: .33rem;
      font-size: .28rem;
      color: #666666;
      font-weight: bold;
    }
    .right-arrow {
      display: inline-block;
      width: .16rem;
      height: .16rem;
      border-top: 2px solid #666666;;
      border-right: 2px solid #666666;;
      transform: rotate(45deg);
    }
  }
}
</style>
